"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  CREATE: "@@tenantInteraction/create",
  UPDATE: "@@tenantInteraction/update",
  FETCH: "@@tenantInteraction/fetch",
  FETCH_LIST: "@@tenantInteraction/fetchList",
  SOFT_DELETE: "@@tenantInteraction/softDelete",
  HARD_DELETE: "@@tenantInteraction/hardDelete",
  RESTORE: "@@tenantInteraction/restore",
  SOFT_DELETE_LIST: "@@tenantInteraction/softDeleteList",
  SOFT_DELETE_BULK: "@@tenantInteraction/softDeleteBulk",
  DELETE_BULK: "@@tenantInteraction/deleteBulk",
  RESTORE_BULK: "@@tenantInteraction/restoreBulk",
  FINAL_SAVE: "@@tenantInteraction/finalSave",
  FINAL_UPDATE: "@@tenantInteraction/finalUpdate",
  SUB_FOLDER_LIST: "@@tenantInteraction/sub-folder-list",
  RESPONSE_LIST: "@@tenantInteraction/response-list",
  RESPONSE_SUBMIT: "@@tenantInteraction/response-submit",
  RESPONSE_SUBMIT_RESET: "@@tenantInteraction/response-submit-reset",
  RESET: "@@tenantInteraction/reset",
  SUCCESS: "@@tenantInteraction/success",
  ERROR: "@@tenantInteraction/error"
};
exports.actionTypes = actionTypes;